<div class="container">
  <div class="header">
    <mat-icon class="header-icon">redeem</mat-icon>
    <h2>Punkte einlösen</h2>
    <p class="subtitle" *ngIf="!qrCodeGenerated">Gib die Anzahl der Punkte ein, die du einlösen möchtest.</p>
  </div>

  <mat-card class="form-card" *ngIf="!qrCodeGenerated">
    <mat-card-content>
      <form [formGroup]="myForm">
        <div class="amount-stepper">
          <button mat-icon-button class="stepper-btn" type="button" (click)="decreaseAmount()" [disabled]="amountFormControl.value <= 1">
            <mat-icon>remove_circle_outline</mat-icon>
          </button>
          <div class="amount-display">
            <span class="amount-value">{{ amountFormControl.value }}</span>
            <span class="amount-label">von {{ totalUnlockedEncouragementPoints }}</span>
          </div>
          <button mat-icon-button class="stepper-btn" type="button" (click)="increaseAmount()" [disabled]="amountFormControl.value >= totalUnlockedEncouragementPoints">
            <mat-icon>add_circle_outline</mat-icon>
          </button>
        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Kommentar</mat-label>
          <input matInput [formControl]="commentFormControl" placeholder="Grund für den Transfer" />
          <mat-icon matPrefix>comment</mat-icon>
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          class="submit-btn"
          type="submit"
          [disabled]="
            !myForm.valid ||
            amountFormControl.value > totalUnlockedEncouragementPoints
          "
          (click)="generateQrCode()"
        >
          <mat-icon>qr_code_2</mat-icon>
          QR-Code generieren
        </button>
      </form>
    </mat-card-content>
  </mat-card>

  <div class="qr-section" *ngIf="qrCodeGenerated">
    <mat-card class="qr-card">
      <mat-card-content>
        <p class="qr-hint">Lass diesen Code vom Empfänger scannen</p>
        <div class="qr-wrapper">
          <qr-code [value]="qrCodeSource" [size]="280"></qr-code>
        </div>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-button color="warn" (click)="qrCodeGenerated = false">
          <mat-icon>arrow_back</mat-icon>
          Zurück
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>

<button
  *ngIf="userSpecificFinishedTransfers.length > 0"
  mat-fab
  class="history-btn"
  color="primary"
  aria-label="Punkte-Historie"
  (click)="showPointsHistory()"
>
  <mat-icon class="history-icon">history</mat-icon>
</button>
